import { CommonModule, Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-institucion',
  standalone: true,
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './create-institucion.component.html',
  styleUrl: './create-institucion.component.css',
})
export class CreateInstitucionComponent implements OnInit {
  institucionForm!: FormGroup;
  isFormDirty = false;
  showPassword = false;
  fieldOrder = [
    'cod_mod',
    'cen_edu',
    'd_niv_mod',
    'tipssexo',
    'd_tipssexo',
    'gestion',
    'd_gestion',
    'ges_dep',
    'd_ges_dep',
    'director',
    'telefono',
    'email',
    'codcp_inei',
    'codccpp',
    'cen_pob',
    'area_censo',
    'dareacenso',
    'codgeo',
    'd_dpto',
    'd_prov',
    'd_dist',
    'clave',
  ];
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.institucionForm = this.fb.group({
      clave: ['', Validators.required],
      cod_mod: ['', Validators.required],
      cen_edu: ['', Validators.required],
      d_niv_mod: ['', Validators.required],
      tipssexo: ['', Validators.required],
      d_tipssexo: ['', Validators.required],
      gestion: ['', Validators.required],
      d_gestion: ['', Validators.required],
      ges_dep: ['', Validators.required],
      d_ges_dep: ['', Validators.required],
      director: [],
      telefono: [, [Validators.pattern(/^\d{6,9}$/)]],
      email: [, [Validators.email]],
      codcp_inei: [],
      codccpp: ['', Validators.required],
      cen_pob: ['', Validators.required],
      area_censo: ['', Validators.required],
      dareacenso: ['', Validators.required],
      codgeo: ['', Validators.required],
      d_dpto: ['', Validators.required],
      d_prov: ['', Validators.required],
      d_dist: ['', Validators.required],
    });

    this.institucionForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });
  }

  async onSubmit() {
    if (this.institucionForm.invalid) {
      Swal.fire(
        'Advertencia',
        'Por favor, complete todos los campos.',
        'warning'
      );
      return;
    }

    const result = await Swal.fire({
      title: '¿Está seguro?',
      text: '¿Quieres registrar la institución?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, registrar',
      cancelButtonText: 'No, cancelar',
    });

    if (!result.isConfirmed) return;

    Swal.fire({
      title: 'Procesando...',
      text: 'Por favor, espere.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const payload = {
        ...this.institucionForm.value,
      };

      await lastValueFrom(
        this.http.post(environment.apiUrl + '/institucion-educativa', payload)
      );

      Swal.close();
      Swal.fire({
        icon: 'success',
        title: 'Éxito',
        text: 'Institución registrada correctamente',
      });
      this.router.navigate(['/instituciones']);
    } catch (error: unknown) {
      Swal.close();
      let errorMessage = 'Error al registrar la institución';

      if (error instanceof HttpErrorResponse) {
        errorMessage = error.error.message || errorMessage;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      await Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    }
  }

  onBack() {
    if (this.isFormDirty && !confirm('¿Está seguro de salir?')) {
      return;
    }
    this.router.navigate(['/instituciones']);
  }

  @HostListener('window:beforeunload', ['$event'])
  handleUnload(event: Event) {
    if (this.isFormDirty) {
      event.returnValue = true;
    }
  }

  formatLabel(key: string): string {
    return key.toUpperCase();
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
}
